<template>
    <section class="section-hero d-flex align-items-center">
        <div class="container">
            <div class="col px-0 h-100">
                <div class="row justify-content-center h-100">
                    <div class="col-7 col-md-6 col-lg-5 text-center my-auto ">
                        <img src="img/ff/Logo RGB_Logo.png" class="img-fluid">
                    </div>
                    <div class="col-5 col-md-6 col-lg-7">
                        <span class="hide">space</span>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>

<style scoped>
.hide {
    visibility: hidden;
}
</style>
